<script setup lang="ts">
// スマートフォンは対象外。理由を示して PC へ誘導する。
import { ref } from 'vue'
import { useI18n } from '@/i18n'

const emit = defineEmits<{ continue: [] }>()
const { t } = useI18n()
const copied = ref(false)
const url = typeof location !== 'undefined' ? location.origin + location.pathname : 'https://photo.jinchi-lab.com/'
async function copy() {
  try {
    await navigator.clipboard.writeText(url)
    copied.value = true
    setTimeout(() => (copied.value = false), 2000)
  } catch {
    copied.value = false
  }
}
</script>

<template>
  <div class="mobile">
    <div class="box">
      <h1>{{ t('mobile.title') }}</h1>
      <p>{{ t('mobile.body') }}</p>
      <ul>
        <li>{{ t('mobile.r1') }}</li>
        <li>{{ t('mobile.r2') }}</li>
        <li>{{ t('mobile.r3') }}</li>
      </ul>
      <div class="url mono">{{ url }}</div>
      <button class="primary wide" @click="copy">{{ copied ? t('mobile.copied') : t('mobile.copy') }}</button>
      <div class="foot">
        <a href="https://github.com/clostridium81/browser_photo_editor" rel="noopener">{{ t('mobile.repo') }}</a>
        <button class="ghost small" @click="emit('continue')">{{ t('mobile.continue') }}</button>
      </div>
    </div>
  </div>
</template>

<style scoped>
.mobile {
  min-height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
  background: var(--bg-0);
}
.box {
  max-width: 480px;
  width: 100%;
  background: var(--bg-1);
  border: 1px solid var(--line-strong);
  border-radius: var(--radius-lg);
  padding: 20px;
}
h1 {
  font-size: 17px;
  margin: 0 0 10px;
}
p {
  margin: 0 0 10px;
  line-height: 1.6;
}
ul {
  margin: 0 0 14px;
  padding-left: 20px;
  color: var(--fg-2);
  line-height: 1.7;
}
.url {
  background: var(--bg-0);
  border: 1px solid var(--line);
  border-radius: var(--radius-sm);
  padding: 8px;
  font-size: 12px;
  word-break: break-all;
  margin-bottom: 10px;
}
.wide {
  width: 100%;
  height: 40px;
  font-size: 14px;
}
.foot {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 14px;
  font-size: 11px;
}
.small {
  font-size: 11px;
  color: var(--fg-3);
  text-decoration: underline;
  padding: 0;
  height: auto;
}
a {
  color: var(--fg-2);
}
</style>
